import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentYearModule } from './student-year.module';
import { environment } from '../../../../../environments/environment';
import { ViewStudentYearModule } from '../../view/view-student-year/view-student-year.module';

@Injectable({
  providedIn: 'root'
})
export class StudentYearService {
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })
    };

    private headers: HttpHeaders;
    constructor(private http: HttpClient) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    }

    getService(): Observable<StudentYearModule[]> {
        return this.http.get<StudentYearModule[]>(environment.apiURL + 'Main/MNStudentYear/');
    }

    getServiceId(id: number): Observable<StudentYearModule[]> {
        return this.http.get<StudentYearModule[]>(environment.apiURL + 'Main/MNStudentYear/' + id);
    }

    getServiceSearchMNStudentID(mnStudentID: number, yearID: number): Observable<StudentYearModule[]> {
        return this.http.get<StudentYearModule[]>(environment.apiURL + 'Main/ViewMNStudentYear/SearchMNStudentID/?mnStudentID=' + mnStudentID + '&yearID=' + yearID);
    }


    getServiceSendMessage(mnStudentYearID: number, type: string) {
        return this.http.get(environment.apiURL + "View/ViewMNStudentYear/SendMessage/?mnStudentYearID=" + mnStudentYearID + "&type=" + type, { responseType: 'text' });
    }

    postService(formData: StudentYearModule) {
        return this.http.post(environment.apiURL + 'Main/MNStudentYear/', formData);
    }

    getServiceFindParent(phone: string, id: number): Observable<ViewStudentYearModule[]> {
        return this.http.get<ViewStudentYearModule[]>(environment.apiURL + 'View/ViewMNStudentYear/FindParent/?phone=' + phone + '&id=' + id);
    }

}
